<ion-card class="ion-margin">
  <ion-card-content>
    <app-empty-placeholder
      [title]="title"
      [icon]="icon">
    </app-empty-placeholder>
    <ng-content></ng-content>
  </ion-card-content>
</ion-card>